import { defineMessages } from 'react-intl'

export default defineMessages({
  weatherHeadline: {
    id: 'app.weather.headline',
    defaultMessage: 'Weather',
  },
  weatherDescriptionPlaceholder: {
    id: 'app.weather.descriptionPlaceholder',
    defaultMessage: 'e.g. 26 degrees, sunny',
  },
  weatherDescriptionValidation: {
    id: 'app.weather.descriptionValidation',
    defaultMessage: 'Please describe the weather!',
  },
})
